import React from 'react';
import { gifts } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Bonuses() {
  return <section className="px-6 py-12" data-id="element-10" data-mp="pjg4xyy2x3zv">
      <SectionHeading eyebrow="Buying today, you also get…" data-id="element-11" data-mp="plsnoebnvidz">+12 free bonuses</SectionHeading>
      <p className="mt-2.5 text-center text-[15px] leading-[1.6] text-ink-500" data-id="element-12" data-mp="at8v27m50tas">
        All included, at no extra cost when you buy today.
      </p>

      <ul className="mt-8 grid grid-cols-2 gap-3" data-id="element-13" data-mp="1tc05o95my7a">
        {gifts.map(gift => <li key={gift.label} className="flex flex-col rounded-2xl border border-cream-300 bg-white p-3" data-id="element-14" data-mp="5w8pryx43ukq">
            <div className="relative overflow-hidden rounded-xl bg-cream-100" data-id="element-15" data-mp="3o3fys1kz95lf">
              <img src={gift.image} alt={gift.title} className="aspect-square w-full object-contain" loading="lazy" data-id="element-16" data-mp="3t1hkku9sfj0l" />
              <span className="absolute left-2 top-2 rounded-md bg-white/90 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.1em] text-gold-500" data-id="element-17" data-mp="1r80ehv1b2q7y">
                {gift.label}
              </span>
            </div>
            <p className="mt-3 px-0.5 pb-1 text-[14.5px] leading-[1.45] text-ink-800" data-id="element-18" data-mp="3df3chvtlhtn6">
              {gift.title}
            </p>
          </li>)}
      </ul>
    </section>;
}